import { Box, styled } from '@mui/material';

const PREFIX = 'TMDX-Widget';
export const widgetClasses = {
  root: `${PREFIX}-root`,
  draggableWrapper: `${PREFIX}-draggableWrapper`,
  container: `${PREFIX}-container`,
};

export const WidgetStyled = styled(Box, {
  shouldForwardProp: prop => prop !== 'outlined',
})<{ outlined?: boolean }>(({ outlined }) => ({
  [`&.${widgetClasses.root}`]: {
    position: 'relative',
    width: '100%',
    flexGrow: 1,
  },
  [`.${widgetClasses.draggableWrapper}`]: {
    position: 'relative',
    width: '100%',
    flexGrow: 1,
  },
  [`.${widgetClasses.container}`]: {
    border: outlined ? '5px solid black' : 'none',
    position: 'relative',
    width: '100%',
    height: '100%',
    overflow: 'hidden',
    minHeight: 0,
  },
}));
